// Custom JavaScript for Spanish market translations

document.addEventListener('DOMContentLoaded', function() {
  // Check if this is Spanish market in multiple ways: lang attribute (es, es-ES, es-MX, etc.), data attribute, or URL
  const htmlLang = document.documentElement.getAttribute('lang') || '';
  const isSpanishLang = htmlLang.startsWith('es');
  const hasSpanishMarketAttr = document.documentElement.hasAttribute('data-spanish-market');
  const isSpanishMarket = isSpanishLang || hasSpanishMarketAttr;
  
  if (!isSpanishMarket) {
    return;
  }

  // Spanish translations for kiwi size chart
  const spanishTranslations = {
    'Size guides': 'Guía de tallas',
    'Size chart': 'Tabla de tallas',
    'Calculate my size': 'Calcular mi talla',
    'What\'s my size?': '¿Cuál es mi talla?',
    'Size': 'Talla',
    'Chest': 'Pecho',
    'Waist': 'Cintura',
    'Hips': 'Cadera',
    'Length': 'Longitud',
    'Width': 'Ancho',
    'Height': 'Altura',
    'Circumference': 'Circunferencia',
    'Insole Length': 'Longitud de la plantilla',
    'Sleeve': 'Manga',
    'Inner leg length': 'Longitud interior de la pierna',
    'See other sizes:': 'Ver otras tallas:',
    'Close': 'Cerrar',
    'Fit preference': 'Preferencia de ajuste',
    'Tight': 'Ajustado',
    'Regular': 'Regular',
    'Loose': 'Holgado',
    'We recommend the size:': 'Recomendamos la talla:',
    'We couldn\'t find a good match': 'No pudimos encontrar una buena coincidencia',
    'inches': 'pulgadas',
    'cm': 'cm',
    'US': 'US',
    'EU': 'EU',
    'UK': 'UK',
    'International': 'Internacional',
    'Privacy': 'Privacidad',
    'Powered by Kiwi Sizing': 'Desarrollado por Kiwi Sizing',
    'Kiwi Sizing Privacy Policy': 'Política de privacidad de Kiwi Sizing'
  };

  // Function to translate text
  function translateText(element) {
    const originalText = element.textContent.trim();
    const translatedText = spanishTranslations[originalText];
    
    if (translatedText) {
      element.textContent = translatedText;
    }
  }

  // Function to translate all kiwi size chart elements
  function translateKiwiSizeChart() {
    // Find all kiwi sizing modal elements
    const kiwiElements = document.querySelectorAll('.kiwi-sizing-modal, [class*="ks-"]');
    
    kiwiElements.forEach(element => {
      // Translate direct text content
      if (element.childNodes.length === 1 && element.childNodes[0].nodeType === Node.TEXT_NODE) {
        translateText(element);
      }
      
      // Translate child elements
      const childElements = element.querySelectorAll('*');
      childElements.forEach(child => {
        if (child.childNodes.length === 1 && child.childNodes[0].nodeType === Node.TEXT_NODE) {
          translateText(child);
        }
      });
    });

    // Specific translations for common elements
    translateSpecificElements();
  }

  // Function to translate specific elements that might not be caught by general translation
  function translateSpecificElements() {
    // Modal title
    const modalTitle = document.querySelector('.modal-title-header');
    if (modalTitle && modalTitle.textContent.includes('Size guides')) {
      modalTitle.textContent = 'Guía de tallas';
    }

    // Tab texts
    const chartTab = document.querySelector('.ks-modal-tab[data-tab="ks-chart-tab-container"]');
    if (chartTab && chartTab.textContent.includes('Size chart')) {
      chartTab.textContent = 'Tabla de tallas';
    }

    const calculatorTab = document.querySelector('.ks-modal-tab[data-tab="ks-calculator-tab-container"]');
    if (calculatorTab && calculatorTab.textContent.includes('Calculate my size')) {
      calculatorTab.textContent = 'Calcular mi talla';
    }

    // Calculator header
    const calculatorHeader = document.querySelector('.ks-calculator-header');
    if (calculatorHeader && calculatorHeader.textContent.includes('What\'s my size?')) {
      calculatorHeader.textContent = '¿Cuál es mi talla?';
    }

    // Table headers
    const tableHeaders = document.querySelectorAll('.ks-table-header-cell');
    tableHeaders.forEach(header => {
      if (header.textContent.includes('Size')) {
        header.textContent = header.textContent.replace('Size', 'Talla');
      }
      if (header.textContent.includes('Chest')) {
        header.textContent = header.textContent.replace('Chest', 'Pecho');
      }
      if (header.textContent.includes('Waist')) {
        header.textContent = header.textContent.replace('Waist', 'Cintura');
      }
      if (header.textContent.includes('Circumference')) {
        header.textContent = header.textContent.replace('Circumference', 'Circunferencia');
      }
      if (header.textContent.includes('Insole Length')) {
        header.textContent = header.textContent.replace('Insole Length', 'Longitud de la plantilla');
      }
      if (header.textContent.includes('Sleeve')) {
        header.textContent = header.textContent.replace('Sleeve', 'Manga');
      }
      if (header.textContent.includes('Hips')) {
        header.textContent = header.textContent.replace('Hips', 'Cadera');
      }
      if (header.textContent.includes('Inner leg length')) {
        header.textContent = header.textContent.replace('Inner leg length', 'Longitud interior de la pierna');
      }
    });

    // Calculator labels
    const labels = document.querySelectorAll('.element-label span span');
    labels.forEach(label => {
      if (label.textContent.includes('Chest')) {
        label.textContent = label.textContent.replace('Chest', 'Pecho');
      }
      if (label.textContent.includes('Waist')) {
        label.textContent = label.textContent.replace('Waist', 'Cintura');
      }
      if (label.textContent.includes('Fit preference')) {
        label.textContent = label.textContent.replace('Fit preference', 'Preferencia de ajuste');
      }
    });

    // Select options
    const options = document.querySelectorAll('option');
    options.forEach(option => {
      if (option.value === 'slim') {
        option.textContent = 'Ajustado';
      }
      if (option.value === 'regular') {
        option.textContent = 'Regular';
      }
      if (option.value === 'loose') {
        option.textContent = 'Holgado';
      }
    });

    // Calculator result text
    const resultLabels = document.querySelectorAll('.element-label label span');
    resultLabels.forEach(label => {
      if (label.textContent.includes('We recommend the size:')) {
        label.textContent = label.textContent.replace('We recommend the size:', 'Recomendamos la talla:');
      }
    });

    const noResultLabel = document.querySelector('.formula-text-no-result label');
    if (noResultLabel && noResultLabel.textContent.includes('We couldn\'t find a good match')) {
      noResultLabel.textContent = 'No pudimos encontrar una buena coincidencia';
    }

    // Calculator line titles
    const lineTitles = document.querySelectorAll('.ks-calculator-line-title');
    lineTitles.forEach(title => {
      if (title.textContent.includes('Tight')) {
        title.textContent = title.textContent.replace('Tight', 'Ajustado');
      }
      if (title.textContent.includes('Loose')) {
        title.textContent = title.textContent.replace('Loose', 'Holgado');
      }
    });

    // Unit toggle labels
    const unitLabels = document.querySelectorAll('.ks-unit-toggle-label');
    unitLabels.forEach(label => {
      if (label.textContent.includes('inches')) {
        label.textContent = label.textContent.replace('inches', 'pulgadas');
      }
    });

    // Postfix elements
    const postfixElements = document.querySelectorAll('.postfix');
    postfixElements.forEach(postfix => {
      if (postfix.textContent.includes('inches')) {
        postfix.textContent = postfix.textContent.replace('inches', 'pulgadas');
      }
    });

    // Privacy elements
    const privacyElements = document.querySelectorAll('.ks-calculator-privacy-link span');
    privacyElements.forEach(element => {
      if (element.textContent.includes('Privacy')) {
        element.textContent = element.textContent.replace('Privacy', 'Privacidad');
      }
    });

    // Carousel title
    const carouselTitles = document.querySelectorAll('.ks-calculator-carousel-title');
    carouselTitles.forEach(element => {
      if (element.textContent.includes('See other sizes:')) {
        element.textContent = element.textContent.replace('See other sizes:', 'Ver otras tallas:');
      }
    });

    // Powered by text
    const poweredByElements = document.querySelectorAll('.ks-calculator-privacy-content div');
    poweredByElements.forEach(element => {
      if (element.textContent.includes('Powered by Kiwi Sizing')) {
        element.textContent = element.textContent.replace('Powered by Kiwi Sizing', 'Desarrollado por Kiwi Sizing');
      }
      if (element.textContent.includes('Kiwi Sizing Privacy Policy')) {
        element.textContent = element.textContent.replace('Kiwi Sizing Privacy Policy', 'Política de privacidad de Kiwi Sizing');
      }
    });
  }

  // Initial translation
  translateKiwiSizeChart();

  // Watch for dynamically added kiwi size chart elements
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === Node.ELEMENT_NODE) {
            if (node.classList && (node.classList.contains('kiwi-sizing-modal') || node.classList.contains('ks-modal-content-wrapper'))) {
              setTimeout(translateKiwiSizeChart, 100);
            }
            const kiwiElements = node.querySelectorAll && node.querySelectorAll('.kiwi-sizing-modal, [class*="ks-"]');
            if (kiwiElements && kiwiElements.length > 0) {
              setTimeout(translateKiwiSizeChart, 100);
            }
          }
        });
      }
    });
  });

  // Start observing
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Also translate when kiwi size chart is opened (common event)
  document.addEventListener('click', function(event) {
    if (event.target && event.target.closest && event.target.closest('.kiwi-sizing-modal')) {
      setTimeout(translateKiwiSizeChart, 100);
    }
  });

  // Listen for custom events that might be fired by kiwi app
  document.addEventListener('kiwi-sizing-opened', translateKiwiSizeChart);
  document.addEventListener('kiwi-sizing-loaded', translateKiwiSizeChart);

  // Also translate when modal is shown (common pattern)
  const originalAddEventListener = EventTarget.prototype.addEventListener;
  EventTarget.prototype.addEventListener = function(type, listener, options) {
    if (type === 'click' || type === 'DOMContentLoaded') {
      const wrappedListener = function(event) {
        listener.call(this, event);
        if (document.querySelector('.kiwi-sizing-modal')) {
          setTimeout(translateKiwiSizeChart, 100);
        }
      };
      return originalAddEventListener.call(this, type, wrappedListener, options);
    }
    return originalAddEventListener.call(this, type, listener, options);
  };

  // Additional event listeners for better coverage
  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(translateKiwiSizeChart, 500);
  });

  // Listen for any DOM changes that might affect kiwi sizing
  document.addEventListener('DOMNodeInserted', function(event) {
    if (event.target.classList && event.target.classList.contains('kiwi-sizing-modal')) {
      setTimeout(translateKiwiSizeChart, 100);
    }
  });
});
